
<div class="react-container" id="{{formId}}"></div>
 
<button #submitButton mat-button color="primary" style="visibility: hidden; width: 1px; height: 1px;" *ngIf="!isReadOnly"  [attr.form]="'form-react-component-container-' + formTemplate.formTemplateId" type="submit">Submit</button>
